const OPTIONS = {}

const zimmeranzahlMinimum = 0
const zimmeranzahlMaximum = 30
const zimmeranzahlSteps = 0.5

const etageMinimum = 0
const etageMaximum = 20
const etageSteps = 1

const anzahlMinimum = 0
const anzahlMaximum = 5
const anzahlSteps = 1

// Returns an array based on a starting value and a stop value with increments
// -> Descending Order
const rangeDesc = (start, stop, step) =>
	Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step)

// Returns an array based on a starting value and a stop value with increments
// <- Ascending Order
const rangeAsc = (start, stop, step) =>
	Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step)

/** STEP ONE */

// Immobilientyp
OPTIONS.immobilientyp = [
	{ id: 0, name: 'Haus', value: 'Haus' },
	{ id: 1, name: 'Wohnung', value: 'Wohnung' },
]

// Objektart
OPTIONS.objektart = {
	Haus: [
		{ id: 0, name: 'Bungalow', value: 'Bungalow' },
		{ id: 1, name: 'Doppelhaushälfte', value: 'Doppelhaushälfte' },
		{
			id: 2,
			name: 'Einfamilienhaus (freistehend)',
			value: 'Einfamilienhaus (freistehend)',
		},
		{ id: 3, name: 'Mehrfamilienhaus', value: 'Mehrfamilienhaus' },
		{ id: 4, name: 'Reiheneckhaus', value: 'Reiheneckhaus' },
		{ id: 5, name: 'Reihenhaus', value: 'Reihenhaus' },
		{ id: 6, name: 'Reihenmittelhaus', value: 'Reihenmittelhaus' },
		{ id: 7, name: 'Doppelhaushälfte', value: 'Doppelhaushälfte' },
		{ id: 8, name: 'Villa', value: 'Villa' },
		{
			id: 9,
			name: 'Wohnimmobilie (sonstige)',
			value: 'Wohnimmobilie (sonstige)',
		},
	],
	Wohnung: [
		{ id: 0, name: 'Dachgeschoss', value: 'Dachgeschoss' },
		{ id: 1, name: 'Erdgeschosswohnung', value: 'Erdgeschosswohnung' },
		{
			id: 2,
			name: 'Etagenwohnung',
			value: 'Etagenwohnung',
		},
		{ id: 3, name: 'Hochparterre', value: 'Hochparterre' },
		{ id: 4, name: 'Loft', value: 'Loft' },
		{ id: 5, name: 'Maisonette', value: 'Maisonette' },
		{ id: 6, name: 'Penthouse', value: 'Penthouse' },
		{ id: 7, name: 'Sonstige', value: 'Sonstige' },
		{ id: 8, name: 'Souterrain', value: 'Souterrain' },
		{
			id: 9,
			name: 'Terrassenwohnung',
			value: 'Terrassenwohnung',
		},
	],
}

// ausstattung
OPTIONS.ausstattung = [
	{ id: 0, name: 'Einfache Ausstattung', value: 'Einfache Ausstattung' },
	{ id: 1, name: 'Normale Ausstattung', value: 'Normale Ausstattung' },
	{ id: 2, name: 'Gehobene Ausstattung', value: 'Gehobene Ausstattung' },
	{ id: 3, name: 'Luxusausstattung', value: 'Luxusausstattung' },
]

// Zustand
OPTIONS.zustand = [
	{ id: 0, name: 'Abbruchreif', value: 'Abbruchreif' },
	{ id: 1, name: 'Renovierungsbedürftig', value: 'Renovierungsbedürftig' },
	{ id: 2, name: 'Gepflegt', value: 'Gepflegt' },
	{ id: 3, name: 'Modernisiert', value: 'Modernisiert' },
	{ id: 4, name: 'Vollständig renoviert', value: 'Vollständig renoviert' },
	{ id: 5, name: 'Saniert', value: 'Saniert' },
	{ id: 6, name: 'Erstbezug', value: 'Erstbezug' },
]

// Baujahr
OPTIONS.baujahr = OPTIONS.letzteSanierung = () => {
	const currentYear = new Date().getFullYear() + 1

	const years = rangeDesc(currentYear, 1880, -1)

	return years.map((year, index) => {
		return {
			id: index,
			name: year.toString(),
			value: year,
		}
	})
}

/** STEP TWO */

// Zimmeranzahl
OPTIONS.zimmeranzahl = () => {
	const values = rangeAsc(
		zimmeranzahlMinimum,
		zimmeranzahlMaximum,
		zimmeranzahlSteps
	)

	return values.map((value, index) => {
		return {
			id: index,
			name: value.toString().replace('.', ','),
			value: value,
		}
	})
}

// Primärer Bodenbelag
OPTIONS.primärer = [
	{ id: 0, name: 'Laminat', value: 'Laminat' },
	{ id: 1, name: 'Fliesen', value: 'Fliesen' },
	{ id: 2, name: 'Teppich', value: 'Teppich' },
	{ id: 3, name: 'Dielen', value: 'Dielen' },
	{ id: 4, name: 'Parkett', value: 'Parkett' },
]

// Heizungstyp
OPTIONS.heizungstyp = [
	{ id: 0, name: 'Nachtspeicherofen', value: 'Nachtspeicherofen' },
	{ id: 1, name: 'Ofen', value: 'Ofen' },
	{ id: 2, name: 'Elektro-Heizung', value: 'Elektro-Heizung' },
	{ id: 3, name: 'Öl-Heizung', value: 'Öl-Heizung' },
	{ id: 4, name: 'Etagen', value: 'Etagen' },
	{ id: 5, name: 'Zentral', value: 'Zentral' },
	{ id: 6, name: 'Gas', value: 'Gas' },
	{ id: 7, name: 'Fernwärme', value: 'Fernwärme' },
	{ id: 8, name: 'Holz-Pellet', value: 'Holz-Pellet' },
	{ id: 9, name: 'Solar-Heizung', value: 'Solar-Heizung' },
	{ id: 10, name: 'Fußboden', value: 'Fußboden' },
	{ id: 11, name: 'Blockheizkraft', value: 'Blockheizkraft' },
	{ id: 12, name: 'Wärmekraft', value: 'Wärmekraft' },
]

// Balkon/Terrasse
OPTIONS.balkon = OPTIONS.garten = OPTIONS.fußbodenheizung = [
	{ id: 0, name: 'Ja', value: 'Ja' },
	{ id: 1, name: 'Nein', value: 'Nein' },
]

// Energieklasse
OPTIONS.energieklasse = [
	{ id: 0, name: 'bis 75 kWh', value: 'bis 75 kWh' },
	{ id: 1, name: '75-130 kWh', value: '75-130 kWh' },
	{ id: 2, name: '130-200 kWh', value: '130-200 kWh' },
	{ id: 3, name: 'über 200 kWh', value: 'über 200 kWh' },
]

// Etage
OPTIONS.etage = OPTIONS.etagenanzahl = () => {
	const values = rangeAsc(etageMinimum, etageMaximum, etageSteps)

	return values.map((value, index) => {
		return {
			id: index,
			name: value.toString(),
			value: value,
		}
	})
}

// Anzahl Garagen, Carports, Stellplätze
OPTIONS.anzahl = () => {
	const values = rangeAsc(anzahlMinimum, anzahlMaximum, anzahlSteps)

	return values.map((value, index) => {
		return {
			id: index,
			name: value.toString(),
			value: value,
		}
	})
}

// Helligkeit
OPTIONS.helligkeit = [
	{ id: 0, name: 'dunkel', value: 'dunkel' },
	{ id: 1, name: 'etwas dunkler', value: 'etwas dunkler' },
	{ id: 2, name: 'normal', value: 'normal' },
	{ id: 3, name: 'hell', value: 'hell' },
	{ id: 4, name: 'sehr hell', value: 'sehr hell' },
]

/** STEP THREE */

// Lärmbelastung
OPTIONS.lärmbelastung = [
	{ id: 0, name: 'absolut ruhig', value: 'absolut ruhig' },
	{ id: 1, name: 'ruhig', value: 'ruhig' },
	{ id: 2, name: 'normal', value: 'normal' },
	{ id: 3, name: 'etwas lauter', value: 'etwas lauter' },
	{ id: 4, name: 'laut', value: 'laut' },
]

// Verkehrsanbindung
OPTIONS.verkehrsanbindung = [
	{ id: 0, name: 'sehr schlecht', value: 'sehr schlecht' },
	{ id: 1, name: 'schlecht', value: 'schlecht' },
	{ id: 2, name: 'normal', value: 'normal' },
	{ id: 3, name: 'gut', value: 'gut' },
	{ id: 4, name: 'sehr gut', value: 'sehr gut' },
]

// Kultur/Freizeit Angebot
OPTIONS.kultur = [
	{ id: 0, name: 'sehr gering', value: 'sehr gering' },
	{ id: 1, name: 'gering', value: 'gering' },
	{ id: 2, name: 'gut', value: 'gut' },
	{ id: 3, name: 'sehr gut', value: 'sehr gut' },
]

/** STEP FOUR */

// Kunde Typ
OPTIONS.Kundenart = [
	{ id: 0, name: 'Privatperson', value: 'Privatperson' },
	{ id: 1, name: 'Unternehmen', value: 'Unternehmen' },
]

// Anrede
OPTIONS.anrede = [
	{ id: 0, name: 'Herr', value: 'Herr' },
	{ id: 1, name: 'Frau', value: 'Frau' },
	{ id: 3, name: 'Divers', value: 'Divers' },
]

// Land
OPTIONS.land = [
	{ id: 0, name: 'Deutschland', value: 'Deutschland' },
	{ id: 1, name: 'Österreich', value: 'Österreich' },
	{ id: 3, name: 'Schweiz', value: 'Schweiz' },
]

export default OPTIONS
